import BasicModel from '../basic/BasicModel'
export default {
  findNavigation (vm, listener) {
    let action = 'main/sxbCrm/findNavigation.action'
    BasicModel.get(vm, action, null, listener)
  },
  getPermissions (vm, listener) {
    let action = 'main/sxbCrm/getPermissions.action'
    BasicModel.get(vm, action, null, listener)
  },
  channelLogin (vm, params, listener) {
    let action = 'main/channel/login.action'
    BasicModel.post(vm, action, params, listener)
  },
  sxbCrmLogin (vm, params, listener) {
    let action = 'main/sxbCrm/login.action'
    BasicModel.post(vm, action, params, listener)
  },
  getPublicKey (vm, listener) {
    let action = 'main/getPublicKey.action'
    BasicModel.get(vm, action, null, listener)
  },
  loginOut (vm, listener) {
    let action = 'main/loginOut.action'
    BasicModel.post(vm, action, null, listener)
  },
  updatePassword (vm, params, listener) {
    let action = 'main/updatePassword.action'
    BasicModel.post(vm, action, params, listener)
  },
  crmLogin (vm, params, listener) {
    let action = 'main/sxbCrm/tokenLogin.action'
    BasicModel.post(vm, action, params, listener)
  },
  createLoginPage (vm, params, listener) {
    let action = 'weChat/createLoginPage.json'
    BasicModel.post(vm, action, params, listener)
  },
  getPublicAccountInfo (vm, params, listener) {
    let action = 'weChat/getPublicAccountInfo.json'
    BasicModel.post(vm, action, params, listener)
  },
  getBuriedPointInfo: function (vm, params, listener) {
    let action = 'main/getBuriedPointInfo.action'
    BasicModel.get(vm, action, params, listener)
  },
  findBuriedPointEventDatas: function (vm, params, listener) {
    let action = 'main/findBuriedPointEventDatas.action'
    BasicModel.get(vm, action, params, listener)
  },
  synWxCpGroupData (vm, params, listener) {
    let action = 'weChartCpCustom/synWxCpGroupData.action'
    BasicModel.post(vm, action, params, listener)
  },
  sendChatMsg (vm, params, listener) {
    let action = 'weChartCpCustom/sendChatMsg.action'
    BasicModel.post(vm, action, params, listener)
  }
}
